import { NgOptimizedImage } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  input,
} from '@angular/core';

import { Avatar } from '@iw/core/entities';

@Component({
  selector: 'iw-avatar',
  templateUrl: './avatar.component.html',
  styleUrl: './avatar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgOptimizedImage],
})
export class AvatarComponent {
  readonly avatar = input<Avatar>();
  readonly firstName = input<string>('');
  readonly size = input<'small' | 'large'>('small');

  @HostBinding('class')
  get classes(): string {
    return this.size();
  }

  get firstLetter(): string {
    return (this.firstName()?.charAt(0) || '').toUpperCase();
  }
}
